import React from 'react';
import { Link } from 'react-router-dom';
import { TruckIcon } from '@heroicons/react/24/outline';
import { useCompany } from '../contexts/CompanyContext';

const CompanyBranding = ({ size = 'default', linkTo = '/dashboard' }) => {
  const { company, loading } = useCompany();

  const sizes = {
    small: {
      icon: 'h-6 w-6',
      text: 'text-lg font-bold'
    },
    default: {
      icon: 'h-8 w-8',
      text: 'text-xl font-bold'
    },
    large: {
      icon: 'h-12 w-12',
      text: 'text-3xl font-bold'
    }
  };

  const currentSize = sizes[size] || sizes.default;
  const companyName = company?.name || 'AutoShop Pro';

  if (loading) {
    return (
      <div className="flex items-center animate-pulse">
        <div className={`${currentSize.icon} bg-gray-600 rounded`}></div>
        <div className="ml-2 h-6 bg-gray-600 rounded w-32"></div>
      </div>
    );
  }

  const content = (
    <div className="flex items-center">
      {company?.logo?.url ? (
        <img
          src={company.logo.url}
          alt={`${companyName} Logo`}
          className={`${currentSize.icon} object-contain`}
        />
      ) : (
        <TruckIcon className={`${currentSize.icon} text-primary-500`} />
      )}
      <span className={`ml-2 ${currentSize.text} text-white`}>
        {companyName}
      </span>
    </div>
  );

  if (linkTo) {
    return (
      <Link to={linkTo} className="hover:opacity-80 transition-opacity">
        {content}
      </Link>
    );
  }

  return content;
};

export default CompanyBranding;